// John Eldhose 20180521
import { RestfulGet } from './Restful';

export async function logout() {
  const Logout = await RestfulGet('logout', (response) => {
      return (response['data']['status'] === 'true')
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return Logout;
}



// WEBPACK FOOTER //
// ./src/Api/logout.js